import { createFileRoute } from '@tanstack/react-router';
import { PaginaInicial } from '@/components/layout/pagina-inicial';

export const Route = createFileRoute('/_app/')({
  component: PaginaInicial,
});
